
<div class="container login-container">
  <div class="d-flex align-items-center justify-content-center">
      <div class="card card-flat wd-xxl">
          <div class="card-header text-center">
              <img id="logoMouraAMM" class="block-center py-3 mt-1" src="/assets/images/logo-moura.png" alt="Logo Grupo Moura" />
          </div>

          <div *ngIf="shouldShowLogin()" class="card-body">
              <form #form="ngForm" [formGroup]="loginForm" class="form mt-1" (submit)="login()" autocomplete="on">
                  <div class="form-group mb-3">
                      <div class="input-group with-focus">
                          <input type="email" formControlName="email" class="form-control border-right-0"
                            placeholder="Informe seu e-mail" autofocus required email>
                            <div class="input-group-text"><em class="fa fa-user"></em></div>
                      </div>
                      <app-vmessage
                          *ngIf="loginForm.get('email').errors?.required && (form.submitted || loginForm.get('email').touched)"
                          text="E-mail Obrigatório">
                      </app-vmessage>

                      <app-vmessage
                          *ngIf="loginForm.get('email').errors?.email && (form.submitted || loginForm.get('email').touched)"
                          text="E-mail Inválido">
                      </app-vmessage>
                  </div>
                  <div class="form-group mb-3">
                      <div class="input-group with-focus">
                          <input formControlName="password" class="form-control border-right-0" placeholder="Informe sua senha" type="password">
                          <div class="input-group-text"><em class="fa fa-lock"></em></div>
                      </div>
                      <app-vmessage
                          *ngIf="loginForm.get('password').errors?.required && (form.submitted || loginForm.get('password').touched)"
                          text="Campo Obrigatório">
                      </app-vmessage>
                  </div>
                  <div class="clearfix">
                      <a class="btn btn-link text-muted link-underline-light" (click)="userNeedsConfirmationCode = true">Esqueci minha senha</a>
                  </div>
                  <div class="d-grid gap-2">
                    <button [disabled]="loginForm.invalid" class="btn btn-primary btn-block mt-3 mb-2">ENTRAR NO PORTAL</button>
                  </div>
              </form>
          </div>

          <div *ngIf="isUserChangingPasswordByCode()" class="card-body">
            <form #form="ngForm" [formGroup]="resetForm" class="form" (submit)="solicitarNovaSenha()" autocomplete="on">
              <div class="form-group text-muted mb-3">
                Informe o seu e-mail abaixo para receber as instruções de como criar uma nova senha.
              </div>
              <div class="form-group mt-1">
                  <div class="input-group with-focus">
                      <input type="email" formControlName="email" class="form-control border-right-0"
                      placeholder="Informe seu e-mail" autofocus required email>
                      <div class="input-group-text"><em class="fa fa-user"></em></div>
                  </div>
                  <app-vmessage
                      *ngIf="resetForm.get('email').errors?.required && (form.submitted || resetForm.get('email').touched)"
                      text="E-mail Obrigatório">
                  </app-vmessage>

                  <app-vmessage
                      *ngIf="resetForm.get('email').errors?.email && (form.submitted || resetForm.get('email').touched)"
                      text="E-mail Inválido">
                  </app-vmessage>
              </div>
              <div class="d-grid gap-2">
                <button [disabled]="resetForm.invalid" class="btn btn-primary btn-block mt-3 mb-2">ENVIAR CÓDIGO</button>
              </div>
              <div class="row justify-content-center">
                <a class="btn btn-link text-muted link-underline-light" (click)="cleanStateVariables()">Voltar para o login</a>
              </div>
            </form>
        </div>
      </div>
  </div>
</div>
